import { render } from "./Counter.vue?vue&type=template&id=0e1e382d"
import script from "./Counter.vue?vue&type=script&lang=js"
export * from "./Counter.vue?vue&type=script&lang=js"
script.render = render

export default script